import { browserRuntimeFreeze } from 'oidc-spa/browser-runtime-freeze';
import { oidcEarlyInit } from 'oidc-spa/entrypoint';

const { shouldLoadApp } = oidcEarlyInit({
  BASE_URL: import.meta.env.BASE_URL,
  securityDefenses: {
    ...browserRuntimeFreeze(),
  },
});

if (shouldLoadApp) {
  void import('./main.lazy');
}
